"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userVouchesController = function () {
  function userVouchesController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userVouchesController);
  }

  (0, _createClass3.default)(userVouchesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.vouches,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No Vouches."
        },
        columns: [
        // { field: "firstName", title: "First Name", filterable: false, width: "6rem" },
        // { field: "lastName", title: "Last Name", filterable: false, width: "6rem" },
        { field: "fullName", title: "Name", filterable: false, width: "4rem" }, { field: "referenceType", title: "Type", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getVouchReferenceType(dataItem.referenceType, dataItem.otherReferenceType);
          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "4rem" }, { field: "whatWouldYouLikeToSay", title: "Feedback", filterable: false, width: "12rem" }]
      };
    }
  }, {
    key: "_getVouchReferenceType",
    value: function _getVouchReferenceType(status, otherReferenceType) {
      switch (status) {
        case _constants2.default.vouchReferenceType.FAMILY:
          return "Family";
        case _constants2.default.vouchReferenceType.CHILDCAREEMPLOYMENT:
          return "Childcare Employment";
        case _constants2.default.vouchReferenceType.NONCHILDCAREEMPLOYMENT:
          return "Non-childcare Employment";
        case _constants2.default.vouchReferenceType.OTHER:
          return "Other (" + otherReferenceType + ")";
        case _constants2.default.vouchReferenceType.JUGGLESTREET:
          return "Juggle Street";
        case _constants2.default.vouchReferenceType.UNSPECIFIED:
          return "-";
      }
    }
  }, {
    key: "_getVouchStatus",
    value: function _getVouchStatus(status) {
      switch (status) {
        case _constants2.default.vouchStatus.PENDING:
          return "Follow-up";
        case _constants2.default.vouchStatus.APPROVED:
          return "Complete";
        case _constants2.default.vouchStatus.CANCELLED:
          return "Incomplete";
        case _constants2.default.vouchStatus.EXPIRED:
          return "Expired";
        case _constants2.default.vouchStatus.NONE:
          return "-";
      }
    }
  }]);
  return userVouchesController;
}();

exports.default = userVouchesController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-vouches/user-vouches.controller.js
 **/